import { GET_VERSION } from 'actions/cuiVersion';

export default (state = null, action) => {
    switch (action.type) {
        case GET_VERSION:
            return action.payload;
    }

    return state;
}
